import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ExtenderWifiIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-extenderWifi"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M39 9 27 9C25.8957153 9 25 9.89571525 25 11L25 29C25 30.1042847 25.8957153 31 27 31L39 31C40.1042847 31 41 30.1042847 41 29L41 11C41 9.89571525 40.1042847 9 39 9ZM27 11 39 11 39 29 27 29 27 11ZM44 3C44.5128358 3 44.9355072 3.38604019 44.9932723 3.88337887L45 4 45 17C45 17.5522847 44.5522847 18 44 18 43.4871642 18 43.0644928 17.6139598 43.0067277 17.1166211L43 17 43 4C43 3.44771525 43.4477153 3 44 3ZM22 3C22.5128358 3 22.9355072 3.38604019 22.9932723 3.88337887L23 4 23 17C23 17.5522847 22.5522847 18 22 18 21.4871642 18 21.0644928 17.6139598 21.0067277 17.1166211L21 17 21 4C21 3.44771525 21.4477153 3 22 3Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M52.7071,23.7071 C55.2801,21.5431 57.0001,18.4071 57.0001,15.0001 C57.0001,11.5931 55.2801,8.4571 52.7071,6.2931 C51.7281,5.4691 50.3061,6.8771 51.2931,7.7071 C53.4751,9.5421 55.0001,12.0891 55.0001,15.0001 C55.0001,17.9111 53.4751,20.4571 51.2931,22.2931 C50.3071,23.1221 51.7281,24.5311 52.7071,23.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M50.7071 19.7071C52.0891 18.5401 53.0001 16.8301 53.0001 15.0001 53.0001 13.1701 52.0891 11.4601 50.7071 10.2931 50.2951 9.9451 49.6971 9.8881 49.2931 10.2931 48.9351 10.6501 48.8781 11.3571 49.2931 11.7071 49.8781 12.2011 50.2731 12.6541 50.6121 13.3271 50.8611 13.8231 51.0001 14.4341 51.0001 15.0001 51.0001 15.1551 50.9901 15.3101 50.9771 15.4651 50.9691 15.5361 50.9701 15.5341 50.9801 15.4561L50.9631 15.5591C50.9461 15.6441 50.9301 15.7301 50.9101 15.8141 50.8311 16.1531 50.7431 16.4061 50.6361 16.6241 50.2961 17.3201 49.8921 17.7871 49.2931 18.2931 48.8801 18.6411 48.9341 19.3481 49.2931 19.7071 49.7021 20.1161 50.2931 20.0571 50.7071 19.7071M14.7071 22.2929C12.5241 20.4579 11.0001 17.9109 11.0001 14.9999 11.0001 12.0889 12.5241 9.5429 14.7071 7.7069 15.6931 6.8779 14.2721 5.4689 13.2931 6.2929 10.7201 8.4569 9.0001 11.5929 9.0001 14.9999 9.0001 18.4069 10.7201 21.5429 13.2931 23.7069 14.2721 24.5309 15.6941 23.1229 14.7071 22.2929"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M16.7071,18.2929 C16.1221,17.7989 15.7261,17.3459 15.3881,16.6729 C15.1391,16.1769 15.0001,15.5659 15.0001,14.9999 C15.0001,14.8449 15.0091,14.6899 15.0231,14.5349 C15.0311,14.4639 15.0301,14.4659 15.0201,14.5439 C15.0251,14.5089 15.0311,14.4749 15.0371,14.4409 C15.0541,14.3559 15.0701,14.2699 15.0891,14.1859 C15.1681,13.8469 15.2571,13.5939 15.3631,13.3759 C15.7041,12.6799 16.1081,12.2129 16.7071,11.7069 C17.1201,11.3589 17.0661,10.6519 16.7071,10.2929 C16.2981,9.8839 15.7071,9.9429 15.2931,10.2929 C13.9111,11.4599 13.0001,13.1699 13.0001,14.9999 C13.0001,16.8299 13.9111,18.5399 15.2931,19.7069 C15.7051,20.0549 16.3031,20.1119 16.7071,19.7069 C17.0641,19.3499 17.1221,18.6429 16.7071,18.2929"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M31 26C31 26.552 30.552 27 30 27 29.448 27 29 26.552 29 26 29 25.448 29.448 25 30 25 30.552 25 31 25.448 31 26M34 26C34 26.552 33.552 27 33 27 32.448 27 32 26.552 32 26 32 25.448 32.448 25 33 25 33.552 25 34 25.448 34 26M37 26C37 26.552 36.552 27 36 27 35.448 27 35 26.552 35 26 35 25.448 35.448 25 36 25 36.552 25 37 25.448 37 26"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M44 12C44.5522847 12 45 12.4477153 45 13 45 13.5128358 44.6139598 13.9355072 44.1166211 13.9932723L44 14 41 14C40.4477153 14 40 13.5522847 40 13 40 12.4871642 40.3860402 12.0644928 40.8833789 12.0067277L41 12 44 12ZM25 12C25.5522847 12 26 12.4477153 26 13 26 13.5128358 25.6139598 13.9355072 25.1166211 13.9932723L25 14 22 14C21.4477153 14 21 13.5522847 21 13 21 12.4871642 21.3860402 12.0644928 21.8833789 12.0067277L22 12 25 12Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
